import { __debug } from "../Debug/Debug";
import { __delay } from "../Delay/Delay";
import { IChatsChatState, IChatState } from "../Interfaces";

class ChatState {
    private keyLocalStorage: string = `chatsState${this.getUid()}`;
    private chats: IChatsChatState = {};

    constructor() {
        this.initFromLocalStorage();
    }

    private getUid(): string {
        return window.location.search.substr(1).split("&")[0].split("=")[1];
    }

    private initFromLocalStorage() {
        const chatsStr = this.fromLocalStorage();
        if (chatsStr) {
            this.chats = JSON.parse(chatsStr);
        }
    }

    private saveToLocalStorage(context: string) {
        localStorage.setItem(this.keyLocalStorage, JSON.stringify(this.chats));
    }


    private fromLocalStorage(): string | null {
        return localStorage.getItem(this.keyLocalStorage);
    }

    /**
     * Sets chat state
     * @param chatState IChatState
     */
    public set(chatState: IChatState) {
        if (!chatState.chatId) return;

        this.chats[chatState.chatId] = chatState;
        this.saveToLocalStorage("ChatState");
    }

    /**
     * Returns chat state
     * @param chatId string
     */
    public get(chatId: string): IChatState | undefined {
        return this.chats[chatId];
    }

    /**
     * Overrides chat state. Keeps the previous state saved if not provided
     * @param chatState IChatState
     */
    public override(chatState: IChatState) {
        if (!chatState.chatId) return;

        this.chats[chatState.chatId] = {
            ...this.get(chatState.chatId),
            ...chatState
        };

        this.saveToLocalStorage("ChatStateOverride");
    }

    /**
     * Stores chats states in local storage
     */
    private toLocalStorage() {
        localStorage.setItem(this.keyLocalStorage, JSON.stringify(this.chats));
    }

}

// Export ChatState class instance (singleton)
export const __chatState = new ChatState();
